import { Can, Subject } from 'src/hooks/usePermissions';
import { Users } from './Users';
import { Invitations } from './Invitations';

export const UsersTab = () => {
  return (
    <Can operation="read" subject={Subject.USERS}>
      <Users />

      <div className="mt-8">
        <Invitations />
      </div>
    </Can>
  );
};
